import { render } from "./OkModal.vue?vue&type=template&id=63bd80dd&scoped=true"
import script from "./OkModal.vue?vue&type=script&lang=js"
export * from "./OkModal.vue?vue&type=script&lang=js"

import "./OkModal.vue?vue&type=style&index=0&id=63bd80dd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bd80dd"]])

export default __exports__